import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTheme } from 'styled-components';

import { PulseWrapper, Ring } from './styles';

interface Props {
    className?: string;
    show?: boolean;
    total: number;
    /** enable for component to use parent width & height, instead of hardcoded px size. */
    responsive?: boolean;
}

export const Pulse = ({ className, show, total, responsive }: Props) => {
    const theme = useTheme();

    return (
        <AnimatePresence>
            {show && (
                <PulseWrapper
                    className={className}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: theme.transitions.speeds.normal, ease: theme.transitions.eases.cubic }}
                    $responsive={responsive}
                >
                    {Array.from({ length: total }, (_, index) => (
                        <Ring $responsive={responsive} key={index} $index={index} $total={total} />
                    ))}
                </PulseWrapper>
            )}
        </AnimatePresence>
    );
};
